<template>
    <div>
        <div class="innerMainContent">
            <div class="innerHeader">
                <div class="h1Wrap">
                    <svg class="i_calender"><use xlink:href="#i_calender"></use></svg>
                    <div class="innerH1Wrap">
                        <h1>{{ $t('addEvent') }}</h1>
                        <ul class="breadcrumb">
                            <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                            <li><router-link to="/events">{{ $t('menu_events') }}</router-link></li>
                            <li class="active">{{ $t('addEvent') }}</li>
                        </ul>
                    </div>
                </div>
                <div class="editEventActions">
                    <button class="backBtn" @click="this.$parent.goBack">
                        <span>{{ $t('back') }}</span>
                        <svg class="i_back"><use xlink:href="#i_longArr"></use></svg>
                    </button>
                </div>
            </div>
            <ul class="nav nav-tabs tabsWrap">
                <li class="active">
                    <a data-toggle="tab" href="#event_tab">
                        <svg class="i_event_tab"><use xlink:href="#i_event_tab"></use></svg>
                        <span>{{ $t('event') }}</span>
                    </a>
                </li>
                <li>
                    <a data-toggle="tab" href="#offer_tab">
                        <svg class="i_offer_tab"><use xlink:href="#i_offer_tab"></use></svg>
                        <span>{{ $t('offer') }}</span>
                    </a>
                </li>
                <li>
                    <a data-toggle="tab" href="#meeting_tab">
                        <svg class="i_meeting_tab"><use xlink:href="#i_meeting_tab"></use></svg>
                        <span>{{ $t('meeting') }}</span>
                    </a>
                </li>
            </ul>
            <div class="innerBox">
                <div class="tab-content">
                    <div id="event_tab" class="tab-pane fade in active">
                        <form @submit.prevent="addEvent" class="formWrap">
                            <div class="row">
                                <div class="col-xs-12 containerWidth">
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <h2>{{ $t('eventOwnerDetails') }} <!--<span style="font-size: 10pt"> (<a @click.prevent="openExistingClientSelector" style="color:#293b5a;cursor:pointer;">{{ $t('chooseExisting') }}</a>)</span>--></h2>
                                        </div>
                                    </div>
                                    <div class="row" v-if="(client == null)">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="ownerName_1">*{{ $t('eventOwnerName') }} <span>({{ $t('fullName') }})</span></label>
                                                <input type="text" id="ownerName_1" name="ownerName_1" v-model="eventDetails.ownerName" v-bind:required="(client == null ? 'required' : '')">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="ownerEmail_1">*{{ $t('email') }}</label>
                                                <input type="email" id="ownerEmail_1" name="ownerEmail_1" v-model="eventDetails.ownerEmail" v-bind:required="(client == null ? 'required' : '')">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="(client == null)">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="ownerPhone_1">*{{ $t('phone') }} <span>({{ $t('mobile') }})</span></label>
                                                <input type="tel" id="ownerPhone_1" name="ownerPhone_1" v-model="eventDetails.ownerPhone" v-bind:required="(client == null ? 'required' : '')">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="(client != null)">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                {{ $t('eventOwnerName') }}: <strong>{{ clientName }}</strong> | <a style="font-weight: bold;color:#293b5a;cursor: pointer;" @click="client = null">X</a>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <h2>{{ $t('eventDetails') }}</h2>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventName_1">*{{ $t('eventName') }}</label>
                                                <input type="text" id="eventName_1" name="eventName_1" v-model="eventDetails.name" required>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventType_1">*{{ $t('eventType') }}</label>
                                                <div class="selectWrap">
                                                    <select name="eventType_1" id="eventType_1" v-model="eventDetails.type" required>
                                                        <option value="" selected="selected">{{ $t('select') }}</option>
                                                        <option v-for="eventType in this.$store.state.eventTypes" v-bind:value="eventType.id">{{ eventType.title }}</option>
                                                    </select>
                                                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventHallName_1">*{{ $t('hall') }}</label>
                                                <div class="selectWrap">
                                                    <select name="eventHallName_1" v-model="eventDetails.hall" id="eventHallName_1" required>
                                                        <option value="" selected="selected">{{ $t('select') }}</option>
                                                        <option v-for="hall in this.$store.state.halls" v-bind:value="hall.id">{{ hall.name }}</option>
                                                    </select>
                                                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap dateWrap">
                                                <label for="eventDate_1">*{{ $t('eventDate') }}</label>
                                                <date-picker v-model="eventDetails.date" :config="datePickerConfig" required="true" id="eventDate_1"></date-picker>
                                                <svg class="i_calender datePickerIcon"><use xlink:href="#i_calender"></use></svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventGuestsNum_1">*{{ $t('guestsNum') }}</label>
                                                <input type="number" min="1" v-model="eventDetails.guests" id="eventGuestsNum_1" name="eventGuestsNum_1" required>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventGuestsNum_2">{{ $t('guestsSeatingLimit') }}</label>
                                                <input type="number" min="0" v-model="eventDetails.guestsSeatingLimit" id="eventGuestsNum_2" name="eventGuestsNum_2">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 col-xs-12">
                                            <div class="">
                                                <label style="margin-right: 10px">{{
                                                    $t('showTimerTxt') }}<input type="checkbox"
                                                                                v-model="eventDetails.showTimer"
                                                                                value="true"
                                                                                style="-webkit-appearance: checkbox;appearance:checkbox"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 col-xs-12">
                                            <div class="inputWrap textareaWrap">
                                                <label for="eventNotes_1">{{ $t('notes') }}</label>
                                                <textarea name="eventNotes_1" v-model="eventDetails.notes" maxlength="200" id="eventNotes_1" class="noteWrapper"></textarea>
                                                <span class="charsLength"><span class="charNum">200</span>/200</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-xs-12">
                                            <div class="inputWrap">
                                                <label for="services">*{{ $t('servicesLbl') }}</label>
                                                <div class="selectWrap">
                                                    <multiselect label="title" :searchable="false" track-by="id" id="services" :multiple="true" v-model="eventDetails.services" :options="$t('banner_targets')">
                                                        <template slot="option" slot-scope="props">
                                                            <div class="option__desc">{{ props.option.title }}</div>
                                                        </template>
                                                    </multiselect>
                                                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 pull-left">
                                            <div class="inputWrap submitWrap">
                                                <button class="submit">{{ $t('saveEvent') }}</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </form>
                    </div>
                    <div id="offer_tab" class="tab-pane fade">
                        <form action="" id="addEventForm_2" class="formWrap" @submit.prevent="addQuotation">
                            <div class="row">
                                <div class="col-xs-12 containerWidth">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="clientName">*{{ $t('clientName') }}</label>
                                                <input type="text" id="clientName" name="clientName" v-model="quotation.clientName" required>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="location">{{ $t('place') }}</label>
                                                <input type="text" id="location" name="location" v-model="quotation.location">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap dateWrap">
                                                <label for="eventDate_2">*{{ $t('eventDate') }}</label>
                                                <date-picker v-model="quotation.date" :config="datePickerConfig" required="true" id="eventDate_2"></date-picker>
                                                <svg class="i_calender datePickerIcon"><use xlink:href="#i_calender"></use></svg>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="guests">{{ $t('brutoGuests') }}</label>
                                                <input type="number" id="guests" name="guests" v-model="quotation.guests">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="requiredGuests">{{ $t('requiredGuests') }}</label>
                                                <input type="number" id="requiredGuests" name="requiredGuests" v-model="quotation.requiredGuests">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventType_2">*{{ $t('eventType') }}</label>
                                                <div class="selectWrap">
                                                    <select name="eventType_2" id="eventType_2" v-model="quotation.type" required>
                                                        <option value="" selected="selected">{{ $t('select') }}</option>
                                                        <option value="sitting">{{ $t('type_sitting') }}</option>
                                                        <option value="alcohol">{{ $t('type_alcohol') }}</option>
                                                        <option value="eventManagement">{{ $t('type_eventManagement') }}</option>
                                                        <option value="totalManage">{{ $t('type_totalManage') }}</option>
                                                        <option value="seatingAndAlcohol">{{ $t('type_seatingAndAlcohol') }}</option>
                                                        <option value="seatingAndManagement">{{ $t('type_seatingAndManagement') }}</option>
                                                    </select>
                                                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="workers">{{ $t('workersNum') }}</label>
                                                <input type="number" id="workers" name="workers" v-model="quotation.workers">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventFiles_2">{{ $t('files') }}</label>
                                                <div class="fileInputWrap">
                                                    <input type="file" class="fileUploadInput2" id="eventFiles_2" name="file" data-alias=".files_names" @change="uploadFile2" multiple>
                                                    <span class="files_names" v-bind:data-placeholder="$t('addFile')" v-bind:data-limittext="$t('files')"></span>
                                                    <svg class="i_files"><use xlink:href="#i_files"></use></svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="inputWrap textareaWrap">
                                                <label for="eventNotes_2">{{ $t('notes') }}</label>
                                                <textarea name="eventNotes_2" id="eventNotes_2" class="noteWrapper" v-model="quotation.notes"></textarea>
                                                <span class="charsLength"><span class="charNum">200</span>/200</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 pull-left">
                                            <div class="inputWrap submitWrap">
                                                <button class="submit">{{ $t('saveMeeting') }}</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </form>
                    </div>
                    <div id="meeting_tab" class="tab-pane fade">
                        <form action="" id="addEventForm_3" class="formWrap" @submit.prevent="addMeeting">
                            <div class="row">
                                <div class="col-xs-12 containerWidth">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventName_3">*{{ $t('eventName') }}</label>
                                                <input type="text" id="eventName_3" name="eventName_3" v-model="meeting.eventName" required>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventPlace_3">{{ $t('place') }}</label>
                                                <input type="text" id="eventPlace_3" name="eventPlace_3" v-model="meeting.location">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="inputWrap dateWrap">
                                                <label for="eventDate_3">*{{ $t('eventDate') }}</label>
                                                <date-picker v-model="meeting.date" :config="datePickerConfig" required="true" id="eventDate_3"></date-picker>
                                                <svg class="i_calender datePickerIcon"><use xlink:href="#i_calender"></use></svg>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="inputWrap">
                                                <label for="eventFiles_3">{{ $t('files') }}</label>
                                                <div class="fileInputWrap">
                                                    <input type="file" class="fileUploadInput" id="eventFiles_3" name="file" data-alias=".files_names" @change="uploadFile" multiple>
                                                    <span class="files_names" v-bind:data-placeholder="$t('addFile')" v-bind:data-limittext="$t('files')"></span>
                                                    <svg class="i_files"><use xlink:href="#i_files"></use></svg>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="inputWrap textareaWrap">
                                                <label for="eventNotes_3">{{ $t('notes') }}</label>
                                                <textarea name="eventNotes_3" id="eventNotes_3" class="noteWrapper" v-model="meeting.notes"></textarea>
                                                <span class="charsLength"><span class="charNum">200</span>/200</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 pull-left">
                                            <div class="inputWrap submitWrap">
                                                <button class="submit">{{ $t('saveAppointment') }}</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <ClientSelectorModal @setClient="setClient"></ClientSelectorModal>
    </div>
</template>

<script>

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import '@fortawesome/fontawesome-free/css/all.css'

    import ClientSelectorModal from '../../components/Modals/ClientSelectorModal';
    import Multiselect from 'vue-multiselect'
    export default {
        name: 'AddEvent',
        data() {
            return{
                halls:[],
                eventTypes:[],
                client:null,
                clientName:'',
                eventDetails:{
                    ownerName:'',
                    ownerEmail:'',
                    ownerPhone:'',

                    name:'',
                    type:'',
                    date:'',
                    services:[],
                    guests:'',
                    guestsSeatingLimit:0,
                    showTimer:false,
                    notes:'',
                    hall:'',
                    owner:'',
                    admin:'',
                },

                meeting:{
                    date:'',
                    location:'',
                    eventName:'',
                    files:[],
                    notes:''
                },

                quotation:{
                    clientName:'',
                    location:'',
                    date:'',
                    guests:'',
                    workers:'',
                    eventType:'',
                    notes:'',
                    files:[],
                },
                datePickerConfig:{
                    format: 'DD/MM/YYYY HH:mm',
                    useCurrent: true,
                    sideBySide:true,
                    locale:this.$store.state.preferences.lang
                }
            }
        },
        components:{
            datePicker,
            ClientSelectorModal,
            Multiselect
        },
         beforeMount(){

            if(this.$store.state.user.type != 2) this.$router.push('/');

            if(this.$data.halls.length == 0) {
                this.$store.dispatch('getDashboardData')
            }

            if(typeof this.$router.currentRoute.params.date !=='undefined' && this.$router.currentRoute.params.date != ''){
                this.eventDetails.date = new Date(this.$router.currentRoute.params.date);
                this.quotation.date = new Date(this.$router.currentRoute.params.date);
                this.meeting.date = new Date(this.$router.currentRoute.params.date);
            }
         },

        mounted(){
            $(document).ready(function(){
                niceInputFile($("input[type='file']"));
            });
        },

        methods:{
            openExistingClientSelector(){
                $("#modal-choose-client").iziModal({
                    autoOpen: 1,
                });
            },

            setClient(id){
                this.$data.client = id;
                this.$store.dispatch('getUser',id)
                                    .then(response => {
                                        //on success
                                        this.$data.clientName = response.data.name;
                                    })
            },

            addEvent(){
                let o = this.$data.eventDetails;
                if(this.$data.client != null){
                    o.owner = this.$data.client;
                    o.ownerPhone = o.ownerEmail = o.ownerName = ''
                }else{
                    o.owner = '';
                }

                this.$store.dispatch('addEvent',o)
                    .then(response => {
                        //on success
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'success',
                            title:this.$t('eventAdded'),
                            timer:2000
                        })
                            .catch(this.$swal.noop);
                        this.$router.push('/event/' + response.data.type.id + '/' + response.data.id);
                    })
                    .catch(response => {
                        //on err
                        let err = this.$t('fatalError');
                        switch(response.code){
                            case -13:
                                err = this.$t('eventEmailExist');
                                break;

                            case -12:
                                err = this.$t('fieldRequired_' + response.data.field);
                                break;

                            case -16:
                                err = this.$t('passwordsNotMatching');
                                break;

                            case -17:
                                err = this.$t('incorrectPassword');
                                break;
                        }
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:err,
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },

            addMeeting(){
                this.$store.dispatch('addMeeting',this.meeting)
                    .then(response =>{
                        //success
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'success',
                            title:this.$t('appointmentAdded'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        this.$router.push('/event/meeting/' + response.data.id)
                    })
                    .catch(err => {
                        //err
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },

            addQuotation(){
                this.$store.dispatch('addQuotation',this.quotation)
                    .then(response =>{
                        //success
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'success',
                            title:this.$t('quotationAdded'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        this.$router.push('/event/quotation/' + response.data.id)
                    })
                    .catch(err => {
                        //err
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },

            uploadFile(){
                let formData = new FormData();
                let file = document.querySelector('.fileUploadInput');
                for(let _ in file.files) {
                    formData.append("file_" + _, file.files[_]);
                }
                this.$store.dispatch('uploadFile',formData)
                    .then(response =>{
                        //success
                        this.meeting.files = response.map(a => a.id);
                    })
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('uploadFailed'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        console.warn('failed to upload file ' + err.toString());
                    })
            },

            uploadFile2(){
                let formData = new FormData();
                let file = document.querySelector('.fileUploadInput2');
                for(let _ in file.files) {
                    formData.append("file_" + _, file.files[_]);
                }
                this.$store.dispatch('uploadFile',formData)
                    .then(response =>{
                        //success
                        this.quotation.files = response.map(a => a.id);
                    })
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('uploadFailed'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        console.warn('failed to upload file ' + err.toString());
                    })
            },
        }
    }

</script>

<style scoped>

    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .editEventActions .backBtn span{
        color:#7c97c5;
        font-weight:700;
        font-size:1.235rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .backBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:26px;
        height:18px;
        fill:#293b5a;
        margin-right:5px;
    }
    .editEventActions .deleteBtn{
        width:218px;
        height:54px;
        background: #fff;
        border:1px solid #d4d4d4;
        border-radius:27px;
        margin-left:30px;

    }
    .editEventActions .deleteBtn span{
        color:#293b5a;
        font-weight:700;
        font-size:1rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .deleteBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:19px;
        height:23px;
        fill:#849dc8;
        margin-left:10px;
    }
    .innerBox{
        padding:30px;
    }
    .tabsWrap li a span{
        font-weight:bold;
        color:#a3a3a3;
        font-size:1.294rem;
        display:inline-block;
        vertical-align:bottom;
    }
    .tabsWrap li a svg{
        display:inline-block;
        vertical-align:bottom;
        fill:#a3a3a3;
        margin-left:10px;
    }
    .tabsWrap li a svg.i_event_tab{
        width:36px;
        height:36px;
    }
    .tabsWrap li a svg.i_offer_tab{
        width:30px;
        height:36px;
    }
    .tabsWrap li a svg.i_meeting_tab{
        width:31px;
        height:36px;
    }
    .tabsWrap li.active a span{
        color:#7d97c5;
    }
    .tabsWrap li.active a svg{
        fill:#293b5a;
    }
    .nav-tabs>li>a{
        border-radius: 0;
        padding: 15px 40px;
    }
    .nav-tabs>li.active>a, .nav-tabs>li.active>a:hover, .nav-tabs>li.active>a:focus{
        border-color:transparent;
        border-bottom-color:#293b5a;
        background: transparent;
    }
    .nav>li>a:hover, .nav>li>a:focus{
        background-color:transparent;
        border-color:transparent;
    }
    .formWrap .inputWrap{
        margin-top:20px;
    }
    @media only screen and (min-width:580px) and (max-width:768px){
        .editEventActions .deleteBtn{width: 185px;height: 45px;margin-left: 15px;}
        .h1Wrap{width: 210px;}
    }
</style>
